import ExcelJS from "exceljs";

export async function crearExcel(
  fileName = "",
  sheetName = "",
  data = [],
  columns = [],
  bgTitle = "7E8382",
  cTitle = "FFFFFF",
  rowPar = "E8E8E8",
  rowImpar = "FFFFFF"
) {
  // Crear un nuevo libro de trabajo
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Reclutamiento";
  workbook.created = new Date();

  // Agregar una hoja de trabajo
  const worksheet = workbook.addWorksheet(sheetName);

  // Crear columnas a partir de la configuración proporcionada
  worksheet.columns = columns.map((col) => ({
    header: col.Header,
    key: col.accessor,
    style: {
      border: { top: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" }, bottom: { style: "thin" } },
    },
  }));

  // Agregar datos a la hoja de trabajo
  data.forEach((row) => worksheet.addRow(row));

  // Aplicar estilo a los títulos
  columns.forEach((_, index) => {
    const cell = worksheet.getCell(`${columnToLetter(index + 1)}1`);
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: bgTitle },
    };
    cell.font = {
      name: "Arial",
      size: 12,
      color: { argb: cTitle },
      bold: true,
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  });

  // Aplicar estilo a las filas alternas
  worksheet.eachRow((row, rowIndex) => {
    if (rowIndex > 1) {
      const fillColor = rowIndex % 2 === 0 ? rowPar : rowImpar;
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: fillColor },
        };
      });
    }
  });

  // Ajustar el ancho de las columnas
  worksheet.columns.forEach((column) => {
    column.width = 20;
  });

  try {
    // Generar el archivo Excel en memoria
    const buffer = await workbook.xlsx.writeBuffer();

    // Crear un blob a partir del buffer
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear un enlace de descarga y activarlo
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName; // Nombre del archivo para la descarga
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    console.log(`Archivo Excel generado y descargado exitosamente: ${fileName}`);
  } catch (error) {
    console.error("Error al crear el archivo Excel:", error);
  }
}

// Función auxiliar para convertir un índice de columna en una letra
function columnToLetter(column) {
  let temp;
  let letter = "";
  while (column > 0) {
    temp = (column - 1) % 26;
    letter = String.fromCharCode(temp + 65) + letter;
    column = (column - temp - 1) / 26;
  }
  return letter;
}
